import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { LoadingIndicator, Tooltip } from '@components';

import { useDispatch, useSelector } from 'react-redux';
import { RCMA } from './RCMA';
import { RCMB } from './RCMB';
import { Cpa } from './Cpa';
import { HerdeiroLegalAtivo } from './HerdeiroLegalAtivo';
import { MATTemporaria } from './MATTemporaria';
import { ResgatePlanoB } from './ResgatePlanoB';
import { SaldoMAT } from './SaldoMAT';
import { DependentesIR } from './DependentesIR';
import { MAT } from './MAT';
import { MAI } from './MAI';
import { HerdeiroCotas } from './HerdeiroCotas';
import { ContConjulgada } from './ContConjulgada';
import { RevisaoCPA } from './RevisaoCPA';
import { RMP } from './RMP';
import { PPI } from './PPI';
import { PPM } from './PPM';
import { ResgateTaesa } from './ResgateTaesa';
import { BeneficiarioRCM } from './BeneficiarioRCM';
import { TempoContribuicao } from './TempoContribuicao';
import { BeneficiarioTaesa } from './BeneficiarioTaesa';
import { getRequerimentosForms } from '../../../../store/requerimentos/thunks';
import { setDadosPessoaisRequerimento } from '../../../../store/requerimentos/slice';
import { ConversaoMAT } from './ConversaoMAT';
import { RCMVitalicia } from './RCMVitalicia';
import { RCMVariavel } from './RCMVariavel';
import { ManutencaoPlanoB } from './ManutencaoPlanoB';
import { TermoMAI } from './TermoMAI';
import { RetornoContribuicao } from './RetornoContribuicao';
import { SuspensaoContribuicao } from './SuspensaoContribuicao';
import { RecebimentoCorrespondencia } from './RecebimentoCorrespondencia';
import { Contracheque } from './Contracheque';
import { AdiantamentoQuinzenal } from './AdiantamentoQuinzenal';
import { DadosBancarios } from './DadosBancarios';
import { RCMVariavelPlanoB } from './RCMVariavelPlanoB';
import { Isencao } from './Isencao';
import { SimulacaoEmprestimo } from './SimulacaoEmprestimo';
import { HerdeiroLegalAN } from './HerdeiroLegalAN';
import { MAIOptante } from './MAIOptante';
import { MAIAN } from './MAIAN';
import { ContConjulgadaFin } from './ContConjulgadaFin';
import { ContConjulgadaFinVit } from './ContConjulgadaFinVit';
import { PPMHerdeiro } from './PPMHerdeiro';
import { BPDPlanoB } from './BPDPlanoB';
import { BPDTaesa } from './BPDTaesa';
import { AutopatrocinioB } from './AutopatrocinioB';
import { AutopatrocinioTaesa } from './AutopatrocinioTaesa';
import { PortabilidadeB } from './PortabilidadeB';
import { OpcaoRegimeTributacao } from './OpcaoRegimeTributacao';
import { PortabilidadeTaesa } from './PortabilidadeTaesa';
import { SuspensaoTaesa } from './SuspencaoTaesa';
import { RetornoTaesa } from './RetornoTaesa';
import { OpcaoRegimeTributacaoAssistido } from './OpcaoRegimeTributacaoAssisitdo';
import { IsencaoResgate } from './IsencaoResgate';

const formsComponents = (title, reference) => ({
  RCMA: <RCMA title={title} reference={reference} />,
  RCMB: <RCMB title={title} reference={reference} />,
  ResgateSaldoContaParticipanteHerdeiroLegal: (
    <HerdeiroLegalAtivo title={title} reference={reference} />
  ),
  PedidoComplementacaoProporcionalAposentadoria: (
    <Cpa title={title} reference={reference} />
  ),
  ContinuacaoMATTemporaria: (
    <MATTemporaria title={title} reference={reference} />
  ),
  ResgateTotal: <ResgatePlanoB title={title} reference={reference} />,
  SaldoRemanescenteMATTemporaria: (
    <SaldoMAT title={title} reference={reference} />
  ),
  DeclaracaoDependentesDiretosAssistido: (
    <DependentesIR title={title} reference={reference} />
  ),
  RequerimentoBeneficioMelhoriaAposentadoriaTempoContribuicaoEspecialIdade: (
    <MAT title={title} reference={reference} />
  ),
  RequerimentoAvaliacaoInscricaoAlteracaoBeneficiosRCM: (
    <BeneficiarioRCM title={title} reference={reference} />
  ),
  PedidoMelhoriaAposentadoriaInvalidez: (
    <MAI title={title} reference={reference} />
  ),
  PesquisaTempoContribuicaoPrevidenciaria: (
    <TempoContribuicao title={title} reference={reference} />
  ),
  ResgateSaldoRemanescenteContasHerdeiroLegal: (
    <HerdeiroCotas title={title} reference={reference} />
  ),
  ContinuacaoMAT: <ContConjulgada title={title} reference={reference} />,
  PredidoRevisaoComplementacaoProporcionalAposentadoria: (
    <RevisaoCPA title={title} reference={reference} />
  ),
  RendaMensalProgramada: <RMP title={title} reference={reference} />,
  AtualizacaoBeneficiariosTaesaprev: (
    <BeneficiarioTaesa title={title} reference={reference} />
  ),
  PeculioInvalidez: <PPI title={title} reference={reference} />,
  PeculioMorte: <PPM title={title} reference={reference} />,
  ResgateContaTaesaprev: <ResgateTaesa title={title} reference={reference} />,
  ConversaoMAT: <ConversaoMAT title={title} reference={reference} />,
  RCMVitalicia: <RCMVitalicia title={title} reference={reference} />,
  RCMVariavel: <RCMVariavel title={title} reference={reference} />,
  ManutencaoPlanoB: <ManutencaoPlanoB title={title} reference={reference} />,
  TermoMAI: <TermoMAI title={title} reference={reference} />,
  RetornoContribuicao: (
    <RetornoContribuicao title={title} reference={reference} />
  ),
  SuspensaoContribuicao: (
    <SuspensaoContribuicao title={title} reference={reference} />
  ),
  RecebimentoCorrespondencia: (
    <RecebimentoCorrespondencia title={title} reference={reference} />
  ),
  Contracheque: <Contracheque title={title} reference={reference} />,
  AdiantamentoQuinzenal: (
    <AdiantamentoQuinzenal title={title} reference={reference} />
  ),
  AtualizacaoDadosBancarios: (
    <DadosBancarios title={title} reference={reference} />
  ),
  RCMVariavelPlanoB: <RCMVariavelPlanoB title={title} reference={reference} />,
  Isencao: <Isencao title={title} reference={reference} />,
  IsencaoResgate: <IsencaoResgate title={title} reference={reference} />,
  ResgateHerdeiroLegalAN: (
    <HerdeiroLegalAN title={title} reference={reference} />
  ),
  MAIOptante: <MAIOptante title={title} reference={reference} />,
  MAIAN: <MAIAN title={title} reference={reference} />,
  MATFinanceira: <ContConjulgadaFin title={title} reference={reference} />,
  MATFV: <ContConjulgadaFinVit title={title} reference={reference} />,
  PPMHerdeiro: <PPMHerdeiro title={title} reference={reference} />,
  BPDPlanoB: <BPDPlanoB title={title} reference={reference} />,
  BPDTaesa: <BPDTaesa title={title} reference={reference} />,
  AutopatrocinioB: <AutopatrocinioB title={title} reference={reference} />,
  AutopatrocinioTaesa: (
    <AutopatrocinioTaesa title={title} reference={reference} />
  ),
  PortabilidadeB: <PortabilidadeB title={title} reference={reference} />,
  PortabilidadeTaesa: (
    <PortabilidadeTaesa title={title} reference={reference} />
  ),
  OpcaoRegimeTributacao: (
    <OpcaoRegimeTributacao title={title} reference={reference} />
  ),
  OpcaoRegimeTributacaoAssistido: (
    <OpcaoRegimeTributacaoAssistido title={title} reference={reference} />
  ),
  SuspensaoTaesa: <SuspensaoTaesa title={title} reference={reference} />,
  RetornoTaesa: <RetornoTaesa title={title} reference={reference} />,

  SimulacaoEmprestimo: <SimulacaoEmprestimo />,
});

export const NovoRequerimento = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { allForms: formularios, allFormsRequestDone } = useSelector(
    (state) => state.requerimentos
  );

  const { dadosSAPNaoTratados, dadosPessoais } = useSelector(
    (state) => state.user
  );

  useEffect(() => {
    dispatch(getRequerimentosForms());
    dispatch(
      setDadosPessoaisRequerimento({
        ...dadosSAPNaoTratados,
        banco: dadosPessoais.codBanco,
        agencia: dadosPessoais.agencia,
        conta: dadosPessoais.conta,
        digito: dadosPessoais.digitoConta,
      })
    );
  }, [dispatch, dadosPessoais, dadosSAPNaoTratados]);

  return !allFormsRequestDone ? (
    <LoadingIndicator />
  ) : (
    <Routes>
      <Route
        path="/*"
        element={
          <div className="row">
            {formularios.map((formulario) => {
              return (
                <div
                  className="col-12 col-lg-6 col-xl-4 mb-4"
                  key={formulario.nome}
                >
                  <button
                    type="button"
                    className={`card h-100 ${
                      !formulario.habilitado
                        ? 'grey-text'
                        : 'cursor-pointer card-button'
                    }`}
                    onClick={() => {
                      if (formulario.habilitado)
                        navigate(formulario.destino, {
                          replace: false,
                          state: { formulario },
                        });
                    }}
                  >
                    <div className="card-body">
                      <h3 className="fw-bold ts-18">
                        {formulario.nome}
                        {!formulario.habilitado && (
                          <Tooltip title="Para criar um novo requerimento desse tipo é necessário cancelar o requerimento anterior em andamento.">
                            ?
                          </Tooltip>
                        )}
                      </h3>
                    </div>
                    <div className="card-footer">
                      <p className="ts-12 text-muted">{formulario.descricao}</p>
                    </div>
                  </button>
                </div>
              );
            })}
          </div>
        }
      />
      {formularios.map((form) => {
        return (
          <Route
            key={form.referencia}
            path={`/${form.destino}/*`}
            element={
              formsComponents(form.nome, form.referencia)[form.referencia]
            }
          />
        );
      })}
    </Routes>
  );
};
